import { configureStore } from '@reduxjs/toolkit';
import repairRequestReducer from './repairRequest/slice';
import repairRequestListReducer from './repairRequestList/slice';
import inspectionTopReducer from './inspectionTop/slice';
import typeLabelsReducer from './TypeLabels/slice';
import inspectionTypeDataReducer from './inspectionTypeData/slice';
import selectIdsReducer from './selectIds/slice';
import partsSelectionReducer from './partsSelection/slice';
import confirmedInspectionReducer from './confirmedInspection/slice';
import confirmedQcReducer from './confirmedQc/slice';
import ngSampleImagesReducer from './ngSampleImages/slice';
import manualReducer from './manual/slice';
import judgementReducer from './judgement/slice';
import reportReducer from './report/slice';
import accountsInfoReducer from './accountsInfo/slice';
import userInfoReducer from './userInfo/slice';
import codeMasterReducer from './codeMaster/slice';
import marketCodeListReducer from './marketCode/slice';
import historyReducer from './history/slice';
import statusReducer from './status/slice';
import templateReducer from './template/slice';
import templateItemReducer from './templateItem/slice';
import userListReducer from './userManagement/slice';

const store = configureStore({
  reducer: {
    repairRequest: repairRequestReducer,
    repairRequestList: repairRequestListReducer,
    inspectionTop: inspectionTopReducer,
    typeLabels: typeLabelsReducer,
    inspectionTypeData: inspectionTypeDataReducer,
    partsSelection: partsSelectionReducer,
    selectIds: selectIdsReducer,
    confirmedInspection: confirmedInspectionReducer,
    confirmedQc: confirmedQcReducer,
    ngSampleImages: ngSampleImagesReducer,
    manual: manualReducer,
    judgement: judgementReducer,
    report: reportReducer,
    accountsInfo: accountsInfoReducer,
    userInfo: userInfoReducer,
    codeMaster: codeMasterReducer,
    marketCodeList: marketCodeListReducer,
    history: historyReducer,
    status: statusReducer,
    template: templateReducer,
    templateItem: templateItemReducer,
    userList: userListReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
